<div class="chart-container">
  <mat-card>
    <div class="chart-width">
      <canvas id="chartInvBedKbJeMQuadratFkt"></canvas>
    </div>
  </mat-card>
</div>